<template>
	<!-- 左侧 -->
	<div class="slidebar" v-show="$route.path!='/zbgk' && $route.path!='/message'">
		<div class="unilogo">
			<img :src="leftIcon">
			<span>{{leftName}}</span>
		</div>
		<div class="leftbar">
			<el-menu
				router
				@select="setSelect"
				:default-active="leftSelectPath"
				class="el-menu-vertical-demo">
				<div :key="index" v-for="(items,index) in setList(this.slideMenu)">
					<el-menu-item :index="items.path" v-if="!items.children">
						<span slot="title">{{items.name}}</span>
					</el-menu-item>
					<el-submenu v-else
						:index="items.path">
						<template slot="title" >
							<span>{{items.name}}</span>
						</template>
						<el-menu-item-group>
							<template v-for="(itemss,indexs) in setList(items.children)">
								<el-menu-item
									:key="indexs"
									:index="itemss.path">
									{{itemss.name}}
								</el-menu-item>
							</template>
						</el-menu-item-group>
					</el-submenu>
				</div>
				<el-menu-item index="/zfjs" v-if="$store.state.user.userinfo.dwid==804&&leftName=='党建共建'">
					<span slot="title">作风建设</span>
				</el-menu-item>
				<el-menu-item index="/ysxt" v-if="$store.state.user.userinfo.dwid==804&&leftName=='党建共建'">
					<span slot="title">意识形态</span>
				</el-menu-item>
			</el-menu>
		</div>
	</div>
</template>

<script>
	let that;
	import { mapState } from "vuex"
	export default{
		computed:{
			...mapState({
				flag:state=>parseInt(state.user.userinfo.flag),
				leftName:state=>state.user.leftName,
				leftIcon:state=>state.user.leftIcon,
				slideMenu:state=>state.user.leftNav,
				leftSelectPath:state=>state.user.leftSelectPath,
			})
		},
		methods:{
			setSelect(index,indexpath){
				this.$store.commit("setLeftSelect",index)
			},
			// 根据权限控制菜单显示隐藏
			setList(list){
				let arr = [];
				if(list){
					list.forEach(item => {
						if(item.meta.requiresAuth.includes(this.flag)){
							if(item.meta.isMenu == true){
								arr.push(item)
							}
						}
					})
					return arr
				}
			}
		},
		mounted(){
			
		}
		
	}
</script>

 <style lang="scss">
	.slidebar{
		width: 198px;
		height: 100%;
		overflow-y: scroll;
		overflow-x: hidden;
		background: #fff;
		box-shadow: 2px 0px 4px 0px rgba(0, 0, 0, 0.1);
		.el-menu{
			border-right: none !important;
		}
		.el-submenu{
			.el-submenu__title{
				padding-left: 55px !important;
			}
			.el-menu-item{
				padding-left: 65px !important;
			}
		}
		.el-submenu__title{
			font-size: 16px !important;
		}
		.el-menu-item{
			min-width: 100px;
			padding-left: 50px !important;
			padding-right: 0px !important;
			border-left: 4px solid rgba($color: #000000, $alpha: 0);
			font-size: 16px;
		}
		.isActive {
			background: none !important;
			color: #BB0000 !important;
			border-left: 4px solid #BB0000 !important;
		}
		.el-menu-item:hover{
			background: none !important;
			border-left: 4px solid #BB0000 !important;
			color: #BB0000 !important;
		}
		.unilogo{
			width: 80%;
			height: 45px;
			margin: 15px auto;
			display: flex;
			align-items: center;
			justify-content: center;
			img{
				height: 35px;
				width: 35px;
				margin-right: 10px;
			}
			span{
				
			}
		}
	}
	.selectLeft{
		background: none !important;
		border-left: 4px solid #BB0000 !important;
		color: #BB0000 !important;
	}
 </style>